<template>
  <common-contribute-activity
    :preparatoryBackgroundImage="bgImage"
    :submissionBackgroundImage="bgImage"
    :votingBackgroundImage="bgImage"
    rankPath="contribute-scorpio-rank"
    votesType="20241103"
  ></common-contribute-activity>
</template>
<script>
import CommonContributeActivity from '@/components/common-contribute-activity';
import bgImage from './images/bg.jpg';
export default {
  name: 'ContributeScorpio',
  components: {
    CommonContributeActivity
  },
  props: {},
  data() {
    return {
      bgImage
    };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>
